import styled from 'styled-components';
import Image from 'global/Image';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: start;
  align-items: center;
  text-align: center;

  max-width: 355px;
  max-height: 256px;
`;

export const Logo = styled(Image)`
  height: 135px;
  width: 100%;
`;

export const Heading = styled.h3`
  font-size: 18px;
  font-weight: 700;
  line-height: 24.3px;
  padding: 0px 40px;
  margin: 0px;
`;
